import styled from 'styled-components';

export const Carousel = styled.div`
  position: relative;

  overflow: hidden;
  .movies {
    display: grid;
    /* grid-gap: 2rem; */
    grid-template-columns: repeat(1, 1fr);
  }

  @media screen and (min-width: 768px) {
    height: 500px;

    .movies {
      margin: 1rem 0;
      display: flex;
      position: absolute;
      transition: transform 0.4s ease;
    }
  }
`;

export const Controls = styled.div`
  /* ============================  CAROUSEL ========================= */
  &.controls {
    pointer-events: none;
    justify-content: space-between;
    display: none;

    button {
      pointer-events: auto;
      cursor: pointer;
      border: none;
      background-color: var(--nightBlue);
      transition: opacity 0.3s ease;
      opacity: 0.1;
      padding: 0.5rem;
      img {
        width: 1rem;
      }

      &:hover {
        opacity: 0.3;
      }
    }

    @media screen and (min-width: 768px) {
      display: flex;
      height: 25%;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
`;
